import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Pagination as Mpagination } from '@material-ui/lab';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { Hidden, IconButton } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
    '& li > button': {
      display: 'none',
    },
    '& li > div': {
      display: 'none',
    },
    '& li:nth-child(1)>button, & li:last-child>button': {
      display: 'inline-flex', // Show only the first, second, and last <li> elements
    },
    // Also Show the <li> that has a child <button class="Mui-Selected">
    '& li > button.Mui-selected': {
      display: 'inline-flex',
    },
  },
}));

export default function Pagination(props) {
  const { onChange = () => [], count = 1, page = 0, showOutOf = false, limit = 10, loading = false, totalCount = 0, ...restProps } = props
  const classes = useStyles()

  const from = (page - 1) * limit || 0
  const to = page * limit || 0

  return (
    <div className={classes.root}>
      <Hidden only={['xs', 'sm']}>
        <Mpagination
          color="primary"
          count={count}
          disabled={count <= 1}
          page={page}
          onChange={(e, nextPage) => onChange(nextPage)}
          {...restProps}
        />
      </Hidden>
      <Hidden only={['md', 'lg', 'xl']}>
        <div className="d-flex custom-responsive-pagination">
          {showOutOf && <p>{from}-{to} of {totalCount}</p>}
          <IconButton onClick={() => onChange(page - 1)} disabled={loading || page == 1}>
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton onClick={() => onChange(page + 1)} disabled={loading || page == count}>
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </div>
      </Hidden>
    </div>
  );
}